import { render, staticRenderFns } from "./PcRiaLeftSideNavigationMenu.vue?vue&type=template&id=5cb758f8"
import script from "./PcRiaLeftSideNavigationMenu.vue?vue&type=script&lang=js"
export * from "./PcRiaLeftSideNavigationMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
installComponents(component, {VList})
